import React from 'react'
import { graphql } from 'gatsby'

import Layout from '../components/blog/Layout'
import Post from '../components/blog/Post'

const TagPost = ({ data, pageContext }) => {
    const { tag } = pageContext
    const { totalCount } = data.allMarkdownRemark
    const pageHeader = `${totalCount} Post${totalCount === 1 ? '' : 's'} dengan tag "${tag}"`

    return (
        <Layout pageTitle={pageHeader}
            location={{ pathname: `${pageContext.url}` }}
            jokes={["Programmer Itu Perhatian", "Titik Koma Aja Diperhatiin, Apalagi Kamu"]}
        >
            <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3">
                {data.allMarkdownRemark.edges.map(({ node }) => (
                    <div className="col mb-4" key={node.id}>
                        <Post key={node.id}
                            slug={node.fields.slug}
                            title={node.frontmatter.title}
                            author={node.frontmatter.author}
                            date={node.frontmatter.date}
                            body={node.excerpt}
                            tags={node.frontmatter.tags}
                            fluid={node.frontmatter.image.childImageSharp.fluid}
                        />
                    </div>
                ))}
            </div>
        </Layout>
    )
}

export const tagQuery = graphql`
    query($tag: String!) {
        allMarkdownRemark (
            sort: {fields: [frontmatter___date], order: DESC}
            filter: { frontmatter: { tags: { in: [$tag] } } }
        ) {
            totalCount
            edges {
                node {
                    id
                    frontmatter {
                        title
                        date(formatString: "MMM Do YYYY")
                        author
                        tags
                        image {
                            childImageSharp {
                                fluid(maxWidth: 650, maxHeight: 371) {
                                    ...GatsbyImageSharpFluid
                                }
                            }
                        }
                    }
                    fields {
                        slug
                    }
                    excerpt
                }
            }
        }
    }
`

export default TagPost